interface IInputValue {
  name: string;
  value: string;
}

const cpfMask = (value: string) => {
  return value
    .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
    .replace(/(\d{3})(\d)/, '$1.$2') // captura 2 grupos de numero o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1'); // captura 2 numeros seguidos de um traço e não deixa ser digitado mais nada
};

const cepMask = (value: string) => {
  return value
    .replace(/\D/g, '')
    .replace(/(\d{5})(\d)/, '$1-$2')
    .replace(/(-\d{3})\d+?$/, '$1');
};

const cnpjMask = (value: string) => {
  const newValue = value
    .replace(/\D+/g, '') // não deixa ser digitado nenhuma letra
    .replace(/(\d{2})(\d)/, '$1.$2') // captura 2 grupos de número o primeiro com 2 digitos e o segundo de com 3 digitos, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de número
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1/$2') // captura 2 grupos de número o primeiro e o segundo com 3 digitos, separados por /
    .replace(/(\d{4})(\d)/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1');
  return newValue;
};

const CurrencyBR = (value: number): string => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value);
};

const telefoneMask = (value: string) => {
  let valueFormated = value.replace(/\D/g, '');
  valueFormated = valueFormated.replace(/^0/, '');

  if (valueFormated.length > 10) {
    valueFormated = valueFormated.replace(
      /^(\d\d)(\d{5})(\d{4}).*/,
      '($1) $2-$3',
    );
  } else if (valueFormated.length > 5) {
    valueFormated = valueFormated.replace(
      /^(\d\d)(\d{4})(\d{0,4}).*/,
      '($1) $2-$3',
    );
  } else if (valueFormated.length > 2) {
    valueFormated = valueFormated.replace(/^(\d\d)(\d{0,5})/, '($1) $2');
  } else {
    valueFormated = valueFormated.replace(/^(\d*)/, '($1');
  }

  return valueFormated;
};

export const formatUTCDateToBR = (dateString: string) => {
  const date = new Date(dateString);

  const day = String(date.getUTCDate()).padStart(2, '0');
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const year = date.getUTCFullYear();

  return `${day}/${month}/${year}`;
};

export const applyMask = ({ name, value }: IInputValue): string => {
  if (name === 'cpf') {
    return cpfMask(value);
  }
  if (name === 'cep') {
    return cepMask(value);
  }
  if (name === 'telefone') {
    return telefoneMask(value);
  }
  if (name === 'cnpj') {
    return cnpjMask(value);
  }
  if (name === 'real') {
    return CurrencyBR(Number(value));
  }

  return value;
};
